<div class="profile-page bg-secondary">
    <main class="pt-4">
        <div class="container wow fadeIn">
            <legend>Un-Approved</legend>
            <!--Grid row-->
            <div class="row">
                <div class="table-responsive">
                    <b-table striped hover :items="items" :fields="fields">
                        <template #cell(createdOn)="data">
                            <span>{{data.item.createdOn | formateDate}}</span>
                        </template>
                        <template #cell(id)="data">
                            <b-button variant="primary" @click="onApproveClick(data.item)">Approve</b-button>
                        </template>
                        <template #cell(id2)="data">
                          <b-button variant="warning" @click="onRejectClick(data.item)">Reject</b-button>
                      </template>
                    </b-table>
                </div>
            </div>
            <!--Grid row-->
            <b-overlay :show="busy" no-wrap >
                <template #overlay>
                    <div v-if="processing" class="text-center p-4 bg-primary text-light rounded">
                      <b-icon icon="cloud" font-scale="4"></b-icon>
                      <div class="mb-3">Processing...</div>
                      <div class="text-center">
                        <b-spinner type="grow" label="Spinning"></b-spinner>
                      </div>
                    </div>
                    <div
                      v-else
                      ref="dialog"
                      tabindex="-1"
                      role="dialog"
                      aria-modal="false"
                      aria-labelledby="form-confirm-label"
                      class="text-center p-3"
                    >
                      <p><strong id="form-confirm-label">{{approveDetails}}</strong></p>
                      <div class="d-flex">
                        <b-button variant="outline-danger" class="mr-3" @click="onCancel">
                          Cancel
                        </b-button>
                        <b-button variant="outline-success" @click="onOK">OK</b-button>
                      </div>
                    </div>
                  </template>
              </b-overlay>
        </div>
    </main>
    <!--Main layout-->
</div>